import { useState, useCallback } from "react";
import { Row, Col, Drawer, Layout } from "antd";
import { useAuth } from "react-oidc-context";
import { Link } from "react-router-dom";
import Hamburger from "hamburger-react";
import { useIntl } from "react-intl";

import UserInfo from "../userInfo";
import Languages from "../languages";

import "./index.css";

const { Header } = Layout;

const logoUrl = `${process.env.PUBLIC_URL}/logo/logo-dhl.png`;

function NavBar({ onLanguageSetting }) {
  const intl = useIntl();
  const { isAuthenticated } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState();
  const onDrawerClose = useCallback(() => {
    setDrawerOpen(false);
  }, []);

  const onSliderClick = useCallback(() => {
    setDrawerOpen((old) => !old);
  }, []);

  return (
    <Header>
      <Row justify="space-between" align="middle">
        <Col>
          <Link
            to="/"
            title={intl.formatMessage({
              id: "messages.navbar.home",
              defaultMessage: "Přechod na hlavní stránku",
            })}
          >
            <img alt="logo" src={logoUrl} className="navbar-header-logo" />
          </Link>
        </Col>
        <Col span={8}>
          <Row gutter={50} align="middle" justify="end">
            <Col className="language-container">
              <Languages onLanguageSetting={onLanguageSetting} />
            </Col>
            {isAuthenticated && (
              <Col className="user-container">
                <UserInfo />
              </Col>
            )}
            <Col className="drawer-menu-button">
              <Hamburger toggled={drawerOpen} onToggle={onSliderClick} />
            </Col>
          </Row>
        </Col>
      </Row>
      <Drawer
        width={150}
        closable={false}
        open={drawerOpen}
        placement="right"
        onClose={onDrawerClose}
      >
        <Row gutter={[0, 50]} justify="center">
          <Col>
            <UserInfo />
          </Col>
          <Col>
            <Languages onLanguageSetting={onLanguageSetting} />
          </Col>
        </Row>
      </Drawer>
    </Header>
  );
}

export default NavBar;
